export const PLACEHOLDER_IMAGES = {
  hero: {
    gameplay: '/img/features/gameplay.jpg',
    comingSoon: '/img/features/coming-soon.jpg',
    gameplayTitle: '/img/features/gameplay-title.png',
    comingSoonTitle: '/img/features/coming-soon-title.png'
  },
  downloads: {
    browser: '/img/downloads/play-browser.jpg',
    google: '/img/downloads/play-google.jpg',
    appstore: '/img/downloads/play-appstore.jpg'
  },
  features: {
    video: '/img/features/video-thumb.jpg',
    paradisePass: '/img/features/paradise-pass.jpg',
    paradiseTools: '/img/features/paradise-tools.jpg',
    creator: '/img/features/creator-program.jpg',
    roadmap: '/img/features/roadmap.jpg',
    about: '/img/features/about.jpg',
    paradiseCloud: '/img/features/paradisecloud.png',
    videoTitle: '/img/features/video-thumb-title.png',
    paradisePassTitle: '/img/features/paradise-pass-title.png',
    paradiseToolsTitle: '/img/features/paradise-tools-title.png',
    creatorTitle: '/img/features/creator-program-title.png',
    roadmapTitle: '/img/features/roadmap-title.png',
    aboutTitle: '/img/features/about-title.png',
    paradiseCloudTitle: '/img/features/paradise-cloud-title.png'
  }
}; 